import React, { useState, useRef, useContext, useEffect } from "react";
import PlayerDetails from "./playerDetails";
import { OptionsContext } from "../store/params.js";
import { getLSDefaultPlaying, cleanStorageByPlaylist, handlePlayloop, getReaded } from "../data/storageManagement.js";
import PlayerControls from "./playerControls";
// import
import Modal from './modal';
import '../assets/modal.css';

const attrAutoPlay = (audioElement) => {
  if (audioElement.current !== undefined) {
    if (getLSDefaultPlaying() === 1) {
      audioElement.current.autoplay = true;
    } else {
      audioElement.current.autoplay = false;
    }
  }
}

// const origin = window.location.origin;


function Player({ openSettings }) {
  const { params, setParams, updateStorageOncePlayed, getOneSongUnplayed, playedTotal, indexOrder, setIndexOrder, resetAudioListStatus, name } = useContext(OptionsContext);

  const audioElement = useRef(null);

  let [initSongVolume, setInitSongVolume] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageModal, setMessageModal] = useState('');

  // Détermine si on continue de jouer ou pas
  attrAutoPlay(params, audioElement);

  // Quand on passe a une nouvelle chanson, l'id est changé dans les params, et on écoute cet event.
  useEffect(() => {
    if (params.audioLists.length) {
      if (params.audioLists.length < params.indexplay) {
      }
      if (params.indexplay !== -1 && params.audioLists.length) {
        audioElement.current.autoplay = getLSDefaultPlaying();
        attrAutoPlay(params, audioElement);
      }

    }
  }, [params, params.indexplay]);

  const paramsRef = useRef(params);
  paramsRef.current = params;

  // Si nouvelle chanson
  useEffect(() => {
    if (paramsRef.current.audioLists[params.indexplay]) {
      const songVolume = paramsRef.current.audioLists[params.indexplay].volumeSonore !== undefined
        ? paramsRef.current.audioLists[params.indexplay].volumeSonore
        : paramsRef.current.defaultVolume;

      audioElement.current.volume = songVolume;
      setInitSongVolume(songVolume);
    }
  }, [params.indexplay]);


  const idSongSetter = (newId) => {
    setParams((prev) => ({
      ...prev,
      ...{
        indexplay: newId,
      },
    }));
  };

  const handleEndSong = () => {
    // Have to set params.indexplay to false

    if (updateStorageOncePlayed(params.indexplay)) {
      const newId = getOneSongUnplayed(name);
      // console.log("newId", newId, name);
      idSongSetter(newId);
    }
    // ...or was in historical
  };

  const volumeSetter = (value) => {
    setInitSongVolume(value);
    setParams((prev) => ({
      ...prev,
      ...{
        currentVolume: value,
      },
    }));
    audioElement.current.volume = value;
  };

  const getNextPrevSong = (sense) => {
    const allSongs = getReaded();
    const nextOrPrevId = sense === "prev" ? indexOrder - 1 : indexOrder + 1;

    allSongs[name].forEach((status, i) => {
      if (status === nextOrPrevId) {
        idSongSetter(i);
        setIndexOrder(nextOrPrevId);
      }
    });
  };

  const openOtherModal = () => {
    setIsModalOpen(false);
    openSettings();
  }

  const skipSongFromModal = () => {
    setIsModalOpen(false);
    SkipSong();
  }

  const SkipSong = (forwards = true) => {
    if (forwards) {
      if (indexOrder - 1 !== playedTotal) {
        handleEndSong();
      } else {
        getNextPrevSong("next");
      }
    } else {
      if (indexOrder !== 0) {
        getNextPrevSong("prev");
      }
    }
  };

  const refreshData = () => {
    cleanStorageByPlaylist(name);
    resetAudioListStatus();
    window.location.reload();
  }

  const handleAudioError = (e, song) => {
    setMessageModal(
      <div className="modalPlayer">
        <p>Une erreur est survenue dans le chargement de ce morceau : {song.name} -
          situé dans le répertoire suivant : <span>{song.musicSrc}</span></p>
        <p className="subButtons">
          <button className="button" onClick={() => skipSongFromModal()}>Passer au titre suivant</button>
          ou
          <button className="button" onClick={() => openOtherModal()}>Regénérer l'index des morceaux.</button>
        </p>
        <p>
          <pre><code>npm run buildPlaylist</code></pre>
        </p>
      </div>
    );
    setIsModalOpen(true);
  }

  if (params.indexplay === -1) {
    return (<div className="music-player completed">
      <div className="player">
        <p>Vous avez jouez l'ensemble de la playlist. La <span className="link" onClick={() => refreshData()}>rafraîchir</span>.</p>
      </div>
    </div>);
  }

  if (!params.audioLists.length) {
    return (<div className="music-player">
      <div className="player">
        <p>Chargement</p>
      </div>
    </div>)
  }

  return (
    <>
      <div className="music-player">
        <div className="player">
          <PlayerDetails song={params.audioLists[params.indexplay]} />

          <div className="wrapperAudio">
            <button className={`${playedTotal === 0 ? "inactive " : " "}skip-btn prev`} onClick={() => SkipSong(false)} />
            <audio
              src={params.audioLists[params.indexplay].musicSrc}
              ref={audioElement}
              controls={true}
              onEnded={() => { handleEndSong(); handlePlayloop("play") }}
              onPlay={() => handlePlayloop("play")}
              onError={(e) => handleAudioError(e, params.audioLists[params.indexplay])}
              onPause={() => handlePlayloop("stop")}
            ></audio>
            <button className="skip-btn next" onClick={() => SkipSong()} />
          </div>

          <PlayerControls volume={initSongVolume} volumeSetter={volumeSetter} />
        </div>

      </div>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2>Problèmes</h2>
        {messageModal}
      </Modal>
    </>
  );

}

export default Player;
